/**
 * Slick Slider Lazy Loader
 * Lädt slick-slider.js nur wenn Slider-Elemente auf der Seite vorhanden sind
 * Einsparung: 90KB auf Seiten ohne Slider
 */

window.SliderLazyLoader = {

  /**
   * Prüft ob Slider-Elemente auf der Seite vorhanden sind
   * @returns {boolean} True wenn Slider gefunden
   */
  hasSliders: function () {
    // Suche nach verschiedenen Slider-Elementen
    const sliderSelectors = [
      '.cart-product-slider',
      '.product-recommendations-cart',
      "[data-section-type='featured-collection'] .grid",
      '.ts-reviews-list',
      '.subcollections-slider',
      '.subcollections-slider--mobile-only',
      '.swiper-popup-gallery',
      '[data-slick]',
      '.slick-slider',
      '.slider',
      '.carousel',
      '.product-slider',
      '.image-slider',
      '.testimonial-slider',
      '.hero-v2-tiles-slider',
      '.hero-v3-tiles-slider'
    ];

    for (let selector of sliderSelectors) {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        // Prüfe ob Slider wirklich mehrere Elemente hat (sonst kein Slider nötig)
        for (let element of elements) {
          const children = element.children;
          if (children.length > 1) {
            return true;
          }
        }
      }
    }

    return false;
  },

  /**
   * Lädt Slick Slider dynamisch
   */
  loadSlickSlider: function () {
    return new Promise((resolve, reject) => {
      // Prüfe ob bereits geladen
      if (window.jQuery && window.jQuery.fn.slick) {
        resolve();
        return;
      }

      // Verwende verschiedene Pfad-Strategien
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const possiblePaths = [
        window.SLICK_SLIDER_URL, // Korrekte Shopify Asset-URL aus theme.liquid
        '/assets/slick-slider.js',
        shopifyRoot + 'assets/slick-slider.js',
        shopifyRoot.replace(/\/$/, '') + '/assets/slick-slider.js',
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js'
      ].filter(Boolean);

      let currentPathIndex = 0;

      const tryLoadScript = () => {
        if (currentPathIndex >= possiblePaths.length) {
          console.error('❌ Failed to load Slick Slider from all paths');
          reject(new Error('Failed to load Slick Slider from all paths'));
          return;
        }

        const script = document.createElement('script');
        script.src = possiblePaths[currentPathIndex];
        script.async = true;

        script.onload = () => {
          resolve();
        };

        script.onerror = () => {
          currentPathIndex++;
          tryLoadScript(); // Versuche nächsten Pfad
        };

        document.head.appendChild(script);
      };

      tryLoadScript();
    });
  },

  /**
   * Initialisiert Slider nach dem Laden
   */
  initializeSliders: function () {
    // Warte kurz bis jQuery und Slick verfügbar sind
    setTimeout(() => {
      if (window.jQuery && window.jQuery.fn.slick) {

        // Cart Product Slider (aus custom-cart.js - exakte Konfiguration)
        jQuery('.product-recommendations-cart .cart-product-slider').slick({
          dots: false,
          infinite: true,
          speed: 300,
          swipe: true,
          touchMove: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
          prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 580,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        // Collection Header Slider (Mobile-only für 2-3 Collections)
        jQuery('.subcollections-slider--mobile-only').each(function () {
          const $slider = jQuery(this);
          const windowWidth = jQuery(window).width();
          const isMobile = windowWidth <= 768;

          // Debug-Info
          // Nur auf Mobile (≤768px) initialisieren - isVisible Check entfernt!
          if (isMobile && !$slider.hasClass('slick-initialized')) {
            const config = $slider.data('slick') || {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              infinite: true,  // Loop aktiviert
              mobileFirst: true,
              responsive: [{
                breakpoint: 768,
                settings: "unslick"
              }]
            };
            $slider.slick(config);
          } else if (!isMobile) {
            // Desktop: Slider deaktivieren falls vorhanden
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('unslick');
            }
            // Desktop: Element zusätzlich verstecken
            $slider.hide();
          }
        });

        // Collection Header Slider (4+ Collections - alle Geräte)
        jQuery('.subcollections-slider:not(.subcollections-slider--mobile-only)').each(function () {
          const $slider = jQuery(this);
          if (!$slider.hasClass('slick-initialized')) {
            const config = $slider.data('slick') || {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              infinite: true,  // Loop aktiviert
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true  // Loop auch auf Tablet
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true  // Loop auch auf Mobile
                  }
                }
              ]
            };
            $slider.slick(config);
          }
        });

        // Weitere Standard-Slider initialisieren
        jQuery('[data-slick]').each(function () {
          const $slider = jQuery(this);
          if (!$slider.hasClass('slick-initialized')) {
            const config = $slider.data('slick') || {};
            $slider.slick(config);
          }
        });
      }
    }, 0); // Sofortige Initialisierung für bessere Performance
  },

  /**
   * Behandelt Browser-Resize für Collection Hero Slider
   */
  handleSliderResize: function () {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    const windowWidth = jQuery(window).width();
    const isMobile = windowWidth <= 768;
    const isTablet = windowWidth > 768 && windowWidth <= 1200;
    const isDesktop = windowWidth > 1200;

    // Mobile-only Slider (2-3 Collections)
    jQuery('.subcollections-slider--mobile-only').each(function () {
      const $slider = jQuery(this);
      const isInitialized = $slider.hasClass('slick-initialized');

      if (isMobile && !isInitialized) {
        // Mobile: Slider initialisieren
        const config = $slider.data('slick') || {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: true,
          mobileFirst: true,
          responsive: [{
            breakpoint: 768,
            settings: "unslick"
          }]
        };
        $slider.slick(config);
      } else if (!isMobile && isInitialized) {
        // Desktop/Tablet: Slider deaktivieren
        $slider.slick('unslick');
        $slider.hide();
      } else if (isMobile && isInitialized) {
        // Mobile: Slider refresh für korrekte Dimensionen
        $slider.slick('refresh');
      }
    });

    // Standard Slider (4+ Collections)
    jQuery('.subcollections-slider:not(.subcollections-slider--mobile-only)').each(function () {
      const $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) {
        // Slider refresh für korrekte Dimensionen
        $slider.slick('refresh');
      }
    });

    // Hero Banner Tiles (Mobile-only Slider)
    jQuery('.hero-v2-tiles-slider, .hero-v3-tiles-slider').each(function () {
      const $slider = jQuery(this);
      const isMobile = windowWidth <= 768;
      const isInitialized = $slider.hasClass('slick-initialized');

      if (isMobile && !isInitialized) {
        const config = $slider.data('slick') || {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          infinite: true,
          mobileFirst: true,
          speed: 300,
          responsive: [{ breakpoint: 769, settings: 'unslick' }]
        };
        $slider.slick(config);
      } else if (!isMobile && isInitialized) {
        $slider.slick('unslick');
      } else if (isMobile && isInitialized) {
        $slider.slick('refresh');
      }
    });
  },

  /**
   * Event-Handler für dynamisch hinzugefügte Slider
   */
  handleDynamicSliders: function () {
    // Beobachte Änderungen für neue Slider
    if (window.MutationObserver) {
      const observer = new MutationObserver((mutations) => {
        let hasNewSliders = false;

        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Element node
                // Prüfe ob neue Slider hinzugefügt wurden
                const sliderSelectors = ['.cart-product-slider', '[data-slick]', '.slider'];
                for (let selector of sliderSelectors) {
                  if (node.matches && node.matches(selector) || node.querySelector && node.querySelector(selector)) {
                    hasNewSliders = true;
                    break;
                  }
                }
              }
            });
          }
        });

        if (hasNewSliders && !window.jQuery?.fn?.slick) {
          this.checkAndLoad();
        } else if (hasNewSliders && window.jQuery?.fn?.slick) {
          // Slick bereits geladen, nur neue Slider initialisieren
          this.initializeSliders();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  },

  /**
   * Hauptfunktion - Prüft und lädt Slider bei Bedarf
   */
  init: function () {
    // Prüfe sofort nach DOM-Load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.checkAndLoad();
      });
    } else {
      this.checkAndLoad();
    }

    // Handle dynamische Slider
    this.handleDynamicSliders();
  },

  /**
   * Prüft und lädt Slider
   */
  checkAndLoad: function () {
    if (this.hasSliders()) {
      this.loadSlickSlider()
        .then(() => {
          this.initializeSliders();
        })
        .catch(error => {
          console.error('Slider loading failed:', error);
        });
    }
  }
};

// Auto-Initialize
SliderLazyLoader.init();

// Resize Handler für Collection Hero Slider
let resizeTimeout;
window.addEventListener('resize', function () {
  // Debounce: Warte 250ms nach dem letzten Resize-Event
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    // Nur für Collection Hero Slider
    if (document.querySelector('.subcollections-slider') ||
      document.querySelector('.subcollections-slider--mobile-only') ||
      document.querySelector('.hero-v2-tiles-slider') ||
      document.querySelector('.hero-v3-tiles-slider')) {
      SliderLazyLoader.handleSliderResize();
    }
  }, 250);
});
